import React from "react";
import CardList from "./CardList";
import OfflineCardMessage from "./OfflineCardMessage";
import PrivacyButton from "./PrivacyButton";
import MessageScreen from "../app/MessageScreen";
import CardMessage from "./CardMessage";
import "../../assets/styles/cards.css";
import { gtmConstant } from "../../constants/gtmConstant";
import {sendDataLayer} from "../../../src/actions/gtmService";
export default class Cards extends React.Component {
  componentDidMount() {
      sendDataLayer(gtmConstant.SecretCode.FUNNEL_STEP, {
        process_type: gtmConstant.SecretCode.PROCESS_NAME,
        step_title: gtmConstant.SecretCode.STEP_TITLE.CARD_SELECTION,
        step_number:1,
        error_type:gtmConstant.SecretCode.NA
      });
    this.props.setFocus("breadcrumbs.stage");
  }

  handleServerErrors() {
    let error = this.props.error;

    if (error) {
      switch (error.code) {
        case 400:
          return (
            <MessageScreen
              provider={this.props.provider}
              message={error.text}
              onClose={this.props.onCloseMessage}
              type="attention"
            />
          );
          return (
            <MessageScreen
              provider={this.props.provider}
              message="פג תוקף ההזדהות. נא להזדהות מחדש."
              onClose={this.props.onCloseMessage}
              type="error"
            />
          );
        case 501:
          return (
            <MessageScreen
              message={error.text}
              provider={this.props.provider}
              onClose={this.props.onCloseMessage}
              type="error"
            />
          );
        case 401:
          return (
            <MessageScreen
              provider={this.props.provider}
              message="פג תוקף ההזדהות. נא להזדהות מחדש."
              onClose={this.props.onCloseMessage}
              type="error"
            />
          );
        case 200: {
          //  if(error.code == 200)
          //  {

          this.props.onGetPin(this.props.requestedLast4Digits);
          break;
          //   }
          //   else
          //   {

          //     return (<MessageScreen message={error.text} onClose={this.props.onCloseMessage} type="error" />);
          //   }
        }

        case 10:
        case 18:
        case 11:
        case 78:
        case 56:
        case 92:
          return (
            <MessageScreen
              provider={this.props.provider}
              message={error.text}
              onClose={this.props.onCloseMessage}
              type="error"
            />
          );
      }
    }
    return null;
  }

  getBottomCardText(selectedCard) {
    if (selectedCard.retrievalStatus == 1) {
      return (
        <div className="card-bottom-msg msg  color-n" aria-live="polite">
          <div class="desktop-show">
            <div> במסך הבא נציג את הקוד למשיכת מזומן וביצוע עסקאות.</div>
            <div> אין לצלם את המסך</div>
          </div>
          <div class="mobile-show">
            <span> במסך הבא נציג את הקוד למשיכת מזומן </span>
            <span> וביצוע עסקאות. אין לצלם את המסך</span>
          </div>
        </div>
      );
    } else return null;
  }

  getCardMessage(selectedCard) {
    if (selectedCard) {
      if (selectedCard.retrievalStatus == 1)
        return <PrivacyButton onGetPin={this.props.onShowPrivacy} />;

      if (selectedCard.retrievalStatus == 2)
        return (
          <OfflineCardMessage
            last4Digits={selectedCard.last4Digits}
            onExpressToken={this.props.onExpressToken}
          />
        );

      return (
        <CardMessage
          last4Digits={selectedCard.last4Digits}
          retrievalMessage={selectedCard.retrievalStatusMessage}
        />
      );
    }

    return null;
  }

  render() {
    let cardsWrapper = "";

    if (this.props.provider === "default") {
      cardsWrapper = "cal cards-wrapper";
    } else {
      cardsWrapper = "cards-wrapper";
    }
    if (this.props.error) {
      return this.handleServerErrors();
    }

    if (!this.props.cards) {
      return (
        <div role="progressbar">
          <span className="spinner">Loading</span>
        </div>
      );
    }

    let selectedCard = this.props.cards.filter(
      (c) =>
        this.props.requestedLast4Digits &&
        c.last4Digits === this.props.requestedLast4Digits
    );
    selectedCard = selectedCard ? selectedCard[0] : null;
    let srSelectedCard =
      "הכרטיס הנבחר מסתיים בספרות " +
      selectedCard.last4Digits +
      " מסוג " +
      selectedCard.cardBrand +
      " " +
      selectedCard.cardType +
      " על שם " +
      selectedCard.cardOwnerFirstName;

    return (
      <div className={cardsWrapper}>
        <div className="cards-top bg-t">
          <h2 className="title color-n f2">
            <span className="sr-only">שחזור קוד סודי </span>
            <div>
              <span>לאיזה כרטיס נציג</span>
              <span>את הקוד?</span>
            </div>
          </h2>
          <span className="sr-only" aria-live="polite">
            {srSelectedCard}
          </span>
          <CardList
            cards={this.props.cards}
            selectedCard={selectedCard}
            onSelectCard={(last4Digits) => this.props.onSelectCard(last4Digits)}
          />
        </div>
        {this.getBottomCardText(selectedCard)}
        <div className="cards-message bg-t" aria-live="polite">
          <section id="error-section" aria-live="polite">
            {this.getCardMessage(selectedCard)}
          </section>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/card/Cards.jsx